import React from "react";
import { BaseError } from "core/utils/baseError";

type Props = {
  error: BaseError | string | undefined;
};

const Error: React.FC<Props> = ({ error }) => {
  return (
    <div className="submit-wrapper">
      <span className="error-message">{error && String(error)}</span>
    </div>
  );
};

export default Error;
